export const PRODUCTS_PER_PAGE: number = 20;
